const state = {
  menu:[
    { class: 'tv_router', link: 'https://macvardi1.link/', title: 'Maç İzle'},
    //{ class: 'casino_router', link: '/casino', title: 'Casino', icon: '<svg x="0px" y="0px" viewBox="0 0 232.068 232.068" style="enable-background:new 0 0 232.068 232.068;" xml:space="preserve"> <g> <path d="M116.034,0C52.053,0,0,52.053,0,116.034s52.053,116.034,116.033,116.034c63.981,0,116.034-52.053,116.034-116.034   S180.015,0,116.034,0z M106.701,9.034h18v18h-18V9.034z M197.07,116.034c0,44.684-36.353,81.036-81.036,81.036   c-44.683,0-81.035-36.353-81.035-81.036s36.353-81.036,81.035-81.036C160.717,34.998,197.07,71.351,197.07,116.034z M46.738,34.01   l12.728,12.728L46.738,59.466L34.01,46.738L46.738,34.01z M26.701,125.034h-18v-18h18V125.034z M46.738,198.059L34.01,185.331   l12.728-12.728l12.728,12.728L46.738,198.059z M124.701,223.034h-18v-18h18V223.034z M185.33,198.059l-12.728-12.728l12.728-12.728   l12.728,12.728L185.33,198.059z M185.33,59.466l-12.728-12.728L185.33,34.01l12.728,12.728L185.33,59.466z M204.701,125.034v-18h18   v18H204.701z"/> <rect x="100.701" y="93.034" width="12" height="46"/> <rect x="138.701" y="93.034" width="12" height="46"/> <path d="M49.999,116.034c0,36.412,29.623,66.036,66.035,66.036s66.036-29.624,66.036-66.036s-29.624-66.036-66.036-66.036   S49.999,79.622,49.999,116.034z M83.701,147.034h-9v-44h-3v-0.886l4.94-17.114h7.06V147.034z M129.701,90.881   c0-3.782,2.105-5.847,5.833-5.847h19.106c3.703,0,5.06,2.065,5.06,5.847v50.347c0,3.755-1.357,5.806-5.06,5.806h-19.224   c-3.652,0-5.716-2.051-5.716-5.806V90.881z M121.701,90.881v50.347c0,3.755-1.019,5.806-4.723,5.806H97.754   c-3.652,0-6.053-2.051-6.053-5.806V90.881c0-3.782,2.443-5.847,6.171-5.847h19.106C120.681,85.034,121.701,87.099,121.701,90.881z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg'},
  ],
  configSpesific:{
    autoBonus:true,
    discountRequestSite:false,
  },
  //bonusUrl:'https://payment.bonustalepwl.com/esbet?username=',
  footerProviders:['star_crypto','pf_fix','joker_fast','star_papara','jokerpays_bank', 'hizlipapara', 'jokerdepro_papara', 'jokerpayfast','minipay_card','minipay_bank','instant_mft','instant_bank','instant_kk','tether_deposit','btc_deposit'],
  homePayments:['instant_bank','papara','envoy','crypto','creditcard']
}
const getters = {
  getConfigSpesific(state){
    return state.configSpesific
  },
  getMenu(state){
    return state.menu
  },
  bonusUrl(state){
    return state.bonusUrl
  },
  getHomePayments(state){
    return state.homePayments
  },
  footerProviders(state){
    return state.footerProviders
  }
}
export default {
  namespaced: true,
  state,
  getters,
}